import { Icon, IconProps } from "@chakra-ui/react";

export const InIcon = (props: IconProps) => (
  <Icon
    width="34"
    height="34"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M12 9.55C12.917 8.613 14.111 8 15.5 8a5.5 5.5 0 0 1 5.5 5.5V21h-2v-7.5a3.5 3.5 0 0 0-7 0V21h-2V8.5h2v1.05zM5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-1 2h2V21H4V8.5z"
      />
    </g>
  </Icon>
);
